// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.settings-container {
  background-color: white;
  padding: 30px;
  border-radius: 10px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);
}

.settings-title {
  color: #003366;
  text-align: center;
  margin-bottom: 30px;
  font-size: 28px;
  font-weight: bold;
}

.settings-field {
  margin-top: 20px;
}

.settings-button {
  margin-top: 20px;
  width: 100%;
}

.settings-switch {
  display: flex;
  align-items: center;
  margin-top: 20px;
}

.settings-switch-label {
  margin-left: 10px;
  color: #003366;
  font-weight: bold;
}
`, "",{"version":3,"sources":["webpack://./src/pages/Settings/SettingsPage.css"],"names":[],"mappings":"AAAA;EACE,uBAAuB;EACvB,aAAa;EACb,mBAAmB;EACnB,yCAAyC;AAC3C;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,iBAAiB;AACnB","sourcesContent":[".settings-container {\n  background-color: white;\n  padding: 30px;\n  border-radius: 10px;\n  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);\n}\n\n.settings-title {\n  color: #003366;\n  text-align: center;\n  margin-bottom: 30px;\n  font-size: 28px;\n  font-weight: bold;\n}\n\n.settings-field {\n  margin-top: 20px;\n}\n\n.settings-button {\n  margin-top: 20px;\n  width: 100%;\n}\n\n.settings-switch {\n  display: flex;\n  align-items: center;\n  margin-top: 20px;\n}\n\n.settings-switch-label {\n  margin-left: 10px;\n  color: #003366;\n  font-weight: bold;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
